import { all, takeLatest, call, put } from 'redux-saga/effects';

import {
  types,
  fetchSchoolSubjectsSuccess,
  fetchSchoolSubjectsFailure,
} from '@blueberry/redux/dashboard';
import { actions as errorActions } from '@blueberry/redux/error';

import { fetchSchoolSubjects } from '@blueberry/services/apis';

export function* fetchSubjectsFlow() {
  try {
    const response = yield call(fetchSchoolSubjects);

    yield put(fetchSchoolSubjectsSuccess(response));
  } catch (err) {
    yield put(fetchSchoolSubjectsFailure(err));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([takeLatest(types.FETCH_SCHOOL_SUBJECTS, fetchSubjectsFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/dashboard.js